import { render, staticRenderFns } from "./scoretable.vue?vue&type=template&id=8b6b9340&scoped=true"
import script from "./scoretable.vue?vue&type=script&lang=js"
export * from "./scoretable.vue?vue&type=script&lang=js"
import style0 from "./scoretable.vue?vue&type=style&index=0&id=8b6b9340&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6b9340",
  null
  
)

export default component.exports